/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

import {
  HttpClient,
  HttpEvent,
  HttpHeaders,
  HttpResponse
} from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';

import { Observable } from 'rxjs';

import { CampaignProductValidationRequest } from '../model/campaignProductValidationRequest';
import { MgmMilestoneUpdateRequest } from '../model/mgmMilestoneUpdateRequest';
import { MgmMimoPoolItemRequest } from '../model/mgmMimoPoolItemRequest';
import { ResponseB4ACampaignProductValidationDTO } from '../model/responseB4ACampaignProductValidationDTO';
import { ResponseB4AListMgmMilestoneConfigDTO } from '../model/responseB4AListMgmMilestoneConfigDTO';
import { ResponseB4AListMgmMimoForeverPoolDTO } from '../model/responseB4AListMgmMimoForeverPoolDTO';
import { ResponseB4AMgmMilestoneConfigDTO } from '../model/responseB4AMgmMilestoneConfigDTO';
import { ResponseB4AMgmMimoForeverPoolDTO } from '../model/responseB4AMgmMimoForeverPoolDTO';
import { ResponseB4AVoid } from '../model/responseB4AVoid';

import { Configuration } from '../configuration';
import { BASE_PATH } from '../variables';

@Injectable()
export class MgmConfigControllerService {
  public configuration = new Configuration();

  public defaultHeaders = new HttpHeaders();
  protected basePath = 'http://localhost:8080';
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration
  ) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   *
   *
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createMimoPoolItem(
    body: MgmMimoPoolItemRequest,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AMgmMimoForeverPoolDTO>;
  public createMimoPoolItem(
    body: MgmMimoPoolItemRequest,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AMgmMimoForeverPoolDTO>>;
  public createMimoPoolItem(
    body: MgmMimoPoolItemRequest,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AMgmMimoForeverPoolDTO>>;
  public createMimoPoolItem(
    body: MgmMimoPoolItemRequest,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling createMimoPoolItem.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ResponseB4AMgmMimoForeverPoolDTO>(
      'post',
      `${this.basePath}/mgm/mimo-pool`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param poolItemId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteMimoPoolItem(
    poolItemId: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AVoid>;
  public deleteMimoPoolItem(
    poolItemId: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AVoid>>;
  public deleteMimoPoolItem(
    poolItemId: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AVoid>>;
  public deleteMimoPoolItem(
    poolItemId: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (poolItemId === null || poolItemId === undefined) {
      throw new Error(
        'Required parameter poolItemId was null or undefined when calling deleteMimoPoolItem.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ResponseB4AVoid>(
      'delete',
      `${this.basePath}/mgm/mimo-pool/${encodeURIComponent(String(poolItemId))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param milestoneNumber
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getMilestone(
    milestoneNumber: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AMgmMilestoneConfigDTO>;
  public getMilestone(
    milestoneNumber: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AMgmMilestoneConfigDTO>>;
  public getMilestone(
    milestoneNumber: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AMgmMilestoneConfigDTO>>;
  public getMilestone(
    milestoneNumber: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (milestoneNumber === null || milestoneNumber === undefined) {
      throw new Error(
        'Required parameter milestoneNumber was null or undefined when calling getMilestone.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ResponseB4AMgmMilestoneConfigDTO>(
      'get',
      `${this.basePath}/mgm/milestones/${encodeURIComponent(String(milestoneNumber))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public listMilestones(
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AListMgmMilestoneConfigDTO>;
  public listMilestones(
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AListMgmMilestoneConfigDTO>>;
  public listMilestones(
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AListMgmMilestoneConfigDTO>>;
  public listMilestones(
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ResponseB4AListMgmMilestoneConfigDTO>(
      'get',
      `${this.basePath}/mgm/milestones`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public listMimoPool(
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AListMgmMimoForeverPoolDTO>;
  public listMimoPool(
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AListMgmMimoForeverPoolDTO>>;
  public listMimoPool(
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AListMgmMimoForeverPoolDTO>>;
  public listMimoPool(
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ResponseB4AListMgmMimoForeverPoolDTO>(
      'get',
      `${this.basePath}/mgm/mimo-pool`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param body
   * @param milestoneNumber
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateMilestone(
    body: MgmMilestoneUpdateRequest,
    milestoneNumber: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AMgmMilestoneConfigDTO>;
  public updateMilestone(
    body: MgmMilestoneUpdateRequest,
    milestoneNumber: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AMgmMilestoneConfigDTO>>;
  public updateMilestone(
    body: MgmMilestoneUpdateRequest,
    milestoneNumber: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AMgmMilestoneConfigDTO>>;
  public updateMilestone(
    body: MgmMilestoneUpdateRequest,
    milestoneNumber: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling updateMilestone.'
      );
    }

    if (milestoneNumber === null || milestoneNumber === undefined) {
      throw new Error(
        'Required parameter milestoneNumber was null or undefined when calling updateMilestone.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ResponseB4AMgmMilestoneConfigDTO>(
      'put',
      `${this.basePath}/mgm/milestones/${encodeURIComponent(String(milestoneNumber))}`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param body
   * @param poolItemId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateMimoPoolItem(
    body: MgmMimoPoolItemRequest,
    poolItemId: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AMgmMimoForeverPoolDTO>;
  public updateMimoPoolItem(
    body: MgmMimoPoolItemRequest,
    poolItemId: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AMgmMimoForeverPoolDTO>>;
  public updateMimoPoolItem(
    body: MgmMimoPoolItemRequest,
    poolItemId: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AMgmMimoForeverPoolDTO>>;
  public updateMimoPoolItem(
    body: MgmMimoPoolItemRequest,
    poolItemId: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling updateMimoPoolItem.'
      );
    }

    if (poolItemId === null || poolItemId === undefined) {
      throw new Error(
        'Required parameter poolItemId was null or undefined when calling updateMimoPoolItem.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ResponseB4AMgmMimoForeverPoolDTO>(
      'put',
      `${this.basePath}/mgm/mimo-pool/${encodeURIComponent(String(poolItemId))}`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public validateProduct(
    body: CampaignProductValidationRequest,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4ACampaignProductValidationDTO>;
  public validateProduct(
    body: CampaignProductValidationRequest,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4ACampaignProductValidationDTO>>;
  public validateProduct(
    body: CampaignProductValidationRequest,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4ACampaignProductValidationDTO>>;
  public validateProduct(
    body: CampaignProductValidationRequest,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling validateProduct.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ResponseB4ACampaignProductValidationDTO>(
      'post',
      `${this.basePath}/mgm/validate-product`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }
}
